export default "__VITE_ASSET__B6VW$Rof__"